

<h1 class="page-header">NordNative Impressum</h1>

<style>
    body {
        font-family: Arial, sans-serif;
        line-height: 1.6;
        margin: 0;
        padding: 0;
        background-color: #f9f9f9;
        color: #333;
    }

    .container {
        max-width: 800px;
        margin: 50px auto;
        padding: 20px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    p {
        margin-bottom: 15px;
    }

    strong {
        color: #2a7df2;
    }

    a {
        color: #2a7df2;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
</style>

<div class="container">
    <p>
        <strong>NordNative OÜ</strong>
        <br>
        Innovative SaaS Solutions for a Digital World
    </p>

    <p><strong>Address:</strong><br>
        NordNative OÜ<br>
        Kesklinna Linnaosa, Ahtri tn 12, 10151 Tallinn Estonia</p>

    <!-- <p><strong>Contact Information:</strong><br>
        Phone: <a href="tel:[Your Phone Number]">[Your Phone Number]</a><br>
        Email: <a href="mailto:[Your Email Address]">[Your Email Address]</a><br>
        Website: <a href="https://www.nordnative.com" target="_blank">www.nordnative.com</a></p>

    <p><strong>Managing Directors:</strong><br>
       Kamran Ellahi<br>
    </p>

    <p><strong>Company Registration:</strong><br>
        Registered Office: [City, Country]<br>
        Commercial Register: [Registry Name and Number]<br>
        VAT Identification Number: [Your VAT ID]</p> -->

    <h2>Disclaimer</h2>
    <p>The contents of this website were created with great care. However, we cannot guarantee the accuracy,
        completeness, or timeliness of the information provided. As a service provider, we are responsible for our
        content on these pages in accordance with general laws. However, we are not obligated to monitor transmitted or
        stored information or to investigate circumstances that indicate illegal activity. Obligations to remove or
        block the use of information in accordance with general laws remain unaffected. Liability in this regard is only
        possible from the time of knowledge of a specific infringement. Upon notification of such violations, we will
        remove the content immediately.</p>

    <h2>Copyright</h2>
    <p>All content and works on these pages created by NordNative GmbH are subject to copyright law. The reproduction,
        editing, distribution, and any kind of use beyond the limits of copyright require written permission from the
        respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial
        use. Insofar as the content on this site was not created by the operator, third-party copyrights are respected.
        In particular, third-party content is marked as such. If you nevertheless become aware of a copyright
        infringement, please inform us. Upon notification of violations, we will remove the content immediately.</p>

    <h2>External Links</h2>
    <p>Our website may contain links to external websites. We have no control over the content of these external sites.
        Therefore, we cannot accept any liability for their content. The respective provider or operator of the pages is
        always responsible for the contents of the linked pages. At the time of linking, the linked pages were checked
        for possible legal violations. Illegal content was not recognizable at the time of linking. A permanent content
        control of the linked pages is not reasonable without concrete evidence of a violation. Upon notification of
        such violations, we will remove the links immediately.</p>
</div>

<div class="col-xs-12" style="height:50px;"></div>
